import { ErrorMessage, Field, Form, Formik } from "formik";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Col, FormFeedback, FormGroup, Input, Label, Progress } from "reactstrap";
import { resetPasswordValidationSchema } from "./validationSchema";
import { post } from "../../helper/api";
import { useLoaderHelper } from "../../helper/loaderHelper";
import { useState } from "react";

export const ResetPassword = (props: any) => {
  console.log("The Comming Of Data");
  const { token } = useParams();
  const navigate = useNavigate();
  const loader = useLoaderHelper()

  if (!token) {
    navigate("/login");
  }

  return (
    <Formik
      initialValues={{
        password: "",
        confirmPassword: "",
      }}
      validationSchema={resetPasswordValidationSchema}
      onSubmit={async (values, actions) => {
        const result = await post("/resetPassword", {
          token: token,
          password: values.password,
          confirmPassword: values.confirmPassword,
        }, undefined, loader);
        if (result?.status) {
          navigate("/login");
        }
      }}
    >
      {(formProps) => {
        const passwordTracker = {
          uppercase: /[A-Z]/.test(formProps.values.password), // Check for at least one uppercase letter
          lowercase: /[a-z]/.test(formProps.values.password), // Check for at least one lowercase letter
          number: /[0-9]/.test(formProps.values.password), // Check for at least one numeric character
          specialChar: /[~!@#$%^&*()\-_+=\[\]{}\\|;:'",.<>\/?]/.test(formProps.values.password), // Check for at least one special character
          eightCharsOrGreater: formProps.values.password.length >= 8, // Check if password is 8 characters or more
        };
        const passwordStrength = (Object.values(passwordTracker).filter(value => value).length / 5) * 100;
        
        return (
          <Form className="form-horizontal form-login row">
            <FormGroup>
              <Label className="form-label" htmlFor="password"></Label>
              <Field
                className="form-control"
                id="password"
                name="password"
                placeholder="New password"
                type="password"
                
              />

              <ErrorMessage
                name="password"
                component="div"
                className="text-danger"
              />
            </FormGroup>
            <FormGroup>
              <Label className="form-label" htmlFor="password"></Label>
              <Field
                className="form-control"
                id="confirmPassword"
                name="confirmPassword"
                placeholder="Confirm password"
                type="password"
              />
              <ErrorMessage
                name="confirmPassword"
                component="div"
                className="text-danger"
              />
            </FormGroup>
            <Progress
              className="my-3"
              value={passwordStrength}
              color={passwordStrength<=20?"danger":passwordStrength<=40?"warning":passwordStrength<=99?"info":"success"}
            />
            <Col lg="12">
              <Button color="primary" block className="w-100" type="submit">
                Submit
              </Button>
            </Col>
            <Col lg="12" className="text-center">
              <Link to="/login" className="pt-3 d-inline-block mx-auto">
                Sign in
              </Link>
            </Col>
          </Form>
        )
      }}
    </Formik>
  );
};